import {
  Component,
  Input,
  computed,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { QueryClient } from '@tanstack/angular-query-experimental';
import { selectUser } from 'src/app/core/state';

import { AppState } from 'src/app/core/state/app.state';
import {
  TriggeredAlertsScope,
  injectTriggeredAlertsQuery,
  toggleTriggeredAlertExpanded,
} from 'src/app/api/queries/alert.queries';
import { AlertService } from 'src/app/core/services/alert.service';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { LoadingComponent } from '../../../../shared/components/loading/loading.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dropdown-alerts',
  templateUrl: './dropdown-alerts.component.html',
  styleUrls: ['./dropdown-alerts.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DropdownComponent,
    LoadingComponent,
    FaIconComponent,
    DatePipe,
    TranslatePipe,
  ],
})
export class DropdownAlertsComponent {
  @Input() closeMethod!: () => void;

  private readonly store = inject(Store<AppState>);
  private readonly queryClient = inject(QueryClient);
  public readonly alertService = inject(AlertService);

  private readonly user = this.store.selectSignal(selectUser);

  private readonly scope = computed<TriggeredAlertsScope | null>(() => {
    const user = this.user();

    return user?.id
      ? { userId: user.id, companyId: user.active_company_id }
      : null;
  });

  private readonly alertsQuery = injectTriggeredAlertsQuery(this.scope);

  readonly alerts = computed(() => this.alertsQuery.data() ?? []);
  readonly alertsLoading = this.alertsQuery.isLoading;
  readonly alertCount = computed(() => this.alerts().length);

  toggleExpandAlert(id: string, event: MouseEvent) {
    event.stopPropagation();
    toggleTriggeredAlertExpanded(this.queryClient, id);
  }
}
